import axios from 'axios'
import { getLocalVar } from '@/libs/Util.js'
import router from '@/router/index.js'

const makeRequest = async (uri, data = {}) => {
    // const baseUrl = `${window.location.protocol}://${window.location.hostname + process.env.URL_PORT}/`
    const protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http'
    const alias = process.env.NODE_ENV === 'production' ? '<>PROJECT_ALIAS<>' : ''
    const baseUrl = `${protocol}://${window.location.hostname + process.env.URL_PORT + alias}/`
    const url = baseUrl + uri
    const result = await axios(
        {
            method: 'post',
            url,
            data: data,
            timeout: 5 * 60 * 1000,
            // withCredentials: true,
            headers: {
                Authorization: `${getLocalVar('SESSIONTOKEN')}`
            }
        }
    ).then(successResponse => {
        return successResponse?.data || successResponse
    }).catch(axiosResponse => {
        // throw axiosResponse
        return { error: true, code: axiosResponse.code, message: axiosResponse.message }
    })
    if (result.error && result.code === 'ERR_NETWORK') {
        router.push({ name: 'offline' })
    }
    return result
}

export { makeRequest }
